import React from 'react';
import { Box, Typography } from '@mui/material';
import { DemandHistorySummary, SeasonalAdvice } from './restockPlan';

const Notes: React.FC<{ notes: string[] }> = ({ notes }) => <>
  {notes.slice(0, 2).map((note) => <Typography key={note} variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>{note}</Typography>)}
  {notes.length > 2 && <Box component="details" sx={{ mt: 0.5 }}>
    <Typography component="summary" variant="caption" sx={{ cursor: 'pointer', color: 'primary.main' }}>查看更多依據</Typography>
    {notes.slice(2).map((note) => <Typography key={note} variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>{note}</Typography>)}
  </Box>}
</>;

const RestockDemandSummary: React.FC<{ history?: DemandHistorySummary; season?: SeasonalAdvice }> = ({ history, season }) => {
  if (!history && !season) return null;
  return <Box sx={{ mt: 1.5, p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}>
    {history && <Box>
      <Typography variant="body2" fontWeight={600}>本次選品依據</Typography>
      <Typography variant="caption" color="text.secondary">
        {history.windows_days.length > 0 ? `參考近 ${history.windows_days.join('、')} 天銷售資料` : '銷售資料範圍待確認'}
        {history.previous_year_available ? '；另參考可取得的去年同期資料。' : '；去年同期資料不足。'}
      </Typography>
      <Notes notes={history.notes} />
    </Box>}
    {season && <Box sx={{ mt: history ? 1 : 0 }}>
      <Typography variant="body2" fontWeight={600}>{season.title}</Typography>
      <Notes notes={season.notes} />
    </Box>}
  </Box>;
};

export default RestockDemandSummary;
